// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { CashRegisterInvoiceHolderFragment } from './cash-register-invoice-holder.fragment.generated';
import { CashRegisterItemFragment } from './cash-register-item.fragment.generated';
import { CashRegisterPaymentFragment } from './cash-register-payment.fragment.generated';
export type CashRegisterReceiptFragment = { __typename?: 'CashRegisterReceiptDTO', invoiceHolder: { __typename?: 'CashRegisterInvoiceHolderDTO', fiscalCode: string | null, lines: Array<string>, lotteryCode: string | null } | null, items: Array<{ __typename?: 'CashRegisterItemDTO', amount: number | null, description: string | null, note: string | null, type: Types.CashRegisterItemTypeEnumDto, department: { __typename?: 'DepartmentDTO', atecoCodeId: number | null, cashRegisterCode: string | null, description: string, id: number, sellGoods: boolean, vatRateId: number, atecoCode: { __typename?: 'AtecoCodeDTO', cashRegisterCode: string | null, code: string, description: string, id: number, ownerId: number } | null, vatRate: { __typename?: 'VatRateDTO', atecoCodeId: number | null, cashRegisterCode: string | null, description: string, id: number, ownerId: number, rate: number, referenceOnZeroVat: string | null, naturaTypeOnZeroVat: Types.NaturaTypeEnumDto | null, atecoCode: { __typename?: 'AtecoCodeDTO', cashRegisterCode: string | null, code: string, description: string, id: number, ownerId: number } | null } } | null } | null> | null, payments: Array<{ __typename?: 'CashRegisterPaymentDTO', amount: number | null, description: string | null, type: Types.CashRegisterPaymentTypeEnumDto } | null> | null };

export const CashRegisterReceiptFragment = gql`
    fragment CashRegisterReceipt on CashRegisterReceiptDTO {
  invoiceHolder {
    ...CashRegisterInvoiceHolder
  }
  items {
    ...CashRegisterItem
  }
  payments {
    ...CashRegisterPayment
  }
}
    ${CashRegisterInvoiceHolderFragment}
${CashRegisterItemFragment}
${CashRegisterPaymentFragment}`;
/* eslint-enable */